<span class="flex" [innerHTML]="svgContent" [style]="iconSizeStyle"></span>
